import { httpCreate } from './http';

const http = httpCreate('/srv/activityVideoLive');

export const activityVideoLive = {
	getInfo(id) {
		return http.get(`/${id}`);
	},
	open(id, status, data) {
		return http.post(`/${id}/open/${status}`, data);
	},
	close(id, status) {
		return http.post(`/${id}/close/${status}`);
	},
	// updateThirdPartyUrl(id, data) {
	// 	return http.post(`/${id}/updateThirdPartyUrl`, data);
	// },
	getWXACode(id) {
		return http.get(`/getWXACode/${id}`);
	},
	changeRecord(id, isOpen) {
		return http.put(`/${id}/playback/${isOpen}`);
	},
	getVideoMsg(activityId) {
		return http.get(`/${activityId}`);
	},
	updateThirdPartyUrl(id, data) {
		return http.post(`/${id}/live/updateThirdPartyUrl`, data);
	},
	title(id, fileName) {
		return http.get(`/title/${id}?fileName=${fileName}`);
	},
	swtichPlatform(activityId, platform) {
		return http.post(`/switch-platform/${activityId}/${platform}`);
	},
	changePushStream(activityId) {
		return http.put(`/changePushStream/${activityId}`);
	},
	changeWebrtcStatus(activityId, status) {
		return http.put(`/webrtc/${activityId}/${status}`);
	},
	editDelay(activityId, data) {
		return http.put(`/delay/${activityId}`, data);
	},
	getStreamQuality(activityId, params = {}) {
		return http.get(`/stream-quality/${activityId}`, { params });
	},
	// 获取指定时长的拉流地址
	getPullAddress(id, params) {
		return http.get(`/stream/${id}`, { params });
	},
	// 定制获取指定时长
	getRtmpStreamUrl(id, params) {
		return http.get(`/rtmp-url/${id}`, { params });
	},
	// 保存自定义拉流地址时长
	getPull(id, params) {
		return http.get(`getPull/${id}`, { params });
	},
};
